export default __webpack_public_path__ + "static/media/shoes1-afterA-768w.56c27089.avif";